export default __webpack_public_path__ + "static/media/Page_40.faae532f.png";